export default __webpack_public_path__ + "assets/images/deb0d5e5db97363716853052c853bd8a.jpg";